module.exports = __webpack_public_path__ + "static/img/communication.f66f64d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/communication.png
// module id = K8yF
// module chunks = 0